export interface PrivilegeConfType {
    code: PrivilegeConfTypeValue;
    name: string;
}

export interface PrivilegeIdentType {
    code: PrivilegeIdentTypeValue;
    name: string;
}

export enum PrivilegeIdentTypeValue {
    None = 'none',
    Doc = 'doc',
    Email = 'email',
    Phone = 'phone',
}

export enum PrivilegeConfTypeValue {
    None = 'none',
    List = 'list',
    Service = 'service',
}
